import React from 'react';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const scrollToContent = () => {
    const element = document.getElementById('hvac');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 130;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 130;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-gray-100 pt-20 overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iIzhCMTgxOCIgc3Ryb2tlLW9wYWNpdHk9Ii4wNSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9nPjwvc3ZnPg==')] opacity-30"></div>
      
      {/* Translucent Background Text Elements */}
      <div className="absolute inset-0 pointer-events-none select-none">
        <div className="absolute top-32 -left-20 text-[180px] font-black text-[#8B1818] opacity-[0.03] transform -rotate-12">
          HVAC
        </div>
        <div className="absolute top-1/4 right-0 text-[160px] font-black text-[#000080] opacity-[0.04] transform rotate-6">
          ELECTRICAL
        </div>
        <div className="absolute bottom-32 left-1/4 text-[140px] font-black text-gray-600 opacity-[0.03] transform -rotate-6">
          AUTOMATION
        </div>
        
        {/* Geometric Shapes */}
        <div className="absolute top-20 right-20 w-64 h-64 border-4 border-[#8B1818] opacity-[0.05] rounded-full"></div>
        <div className="absolute bottom-40 right-1/3 w-48 h-48 border-4 border-[#000080] opacity-[0.06] transform rotate-45"></div>
        <div className="absolute top-1/3 left-10 w-56 h-56 border-4 border-gray-500 opacity-[0.04] rounded-lg transform -rotate-12"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
        <div className="space-y-8">
          <h1 className="text-5xl md:text-7xl font-bold leading-tight">
            <span className="text-[#000080]">Expert Solutions for</span>
            <span className="block mt-2">
              <span className="text-[#8B1818]">Modern Buildings</span>
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Leading provider of HVAC, Electrical, and Door Automation solutions.
            Delivering excellence in every project.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6">
            <button
              onClick={scrollToContact}
              className="bg-[#8B1818] text-white px-8 py-4 rounded-lg hover:bg-[#6B1212] transition-all duration-200 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              Get Started
            </button>
            <button
              onClick={scrollToAbout}
              className="bg-white text-[#000080] px-8 py-4 rounded-lg hover:bg-gray-50 transition-all duration-200 font-semibold text-lg border-2 border-[#000080] shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;